<template>
  <div class="weekly-container clearfix">
    <div class="header">
      <div class="xmmc">{{ params.xmjc }}</div>
      <div>
        <span>周报日期</span>
        <span v-if="weeklyTime == 3">: {{ weekDate }}</span>
        <el-radio-group v-else v-model="weeklyTime" @change="getWeeklyData">
          <el-radio label="1">本周</el-radio>
          <el-radio label="2">上周</el-radio>
        </el-radio-group>
      </div>
      <div>
        <el-button type="primary" @click="editLogDialog = true"
          >编辑日志</el-button
        >
      </div>
    </div>
    <div class="card card1">
      <div class="card-title">
        <span v-if="weeklyTime == 3">{{ weekDate }} 项目团队共投入</span>
        <span v-else
          >项目团队 {{ weeklyTime == 1 ? "本周" : "上周" }}共投入</span
        >
        <span
          @click="allPeopleDialog = true"
          style="color: #036eb8; cursor: pointer"
          >{{ teamWorks.data0.zrs }}</span
        >
        人，{{ teamWorks.data0.ztr }}人/日
      </div>
      <div class="card-content clearfix">
        <div class="card-content-left clearfix">
          <div
            class="card-column"
            v-for="(item, index) in teamWorks.data1.fzr"
            :key="index"
          >
            <div class="item clearfix">
              <el-tooltip placement="top-start">
                <div slot="content">{{ item.fzr }}</div>
                <div>{{ item.fzr }}</div>
              </el-tooltip>
              <el-tooltip placement="top-start" v-if="item.xm">
                <div slot="content">{{ item.xm }}({{ item.gwmc }})</div>
                <div>{{ item.xm }}({{ item.gwmc }})</div>
              </el-tooltip>
              <span v-else>/</span>
            </div>
            <div class="item clearfix">
              <div>{{ weeklyName }}投入</div>
              <div v-if="item.zgzl">
                <span>{{ item.zgzl }}（人/日)</span>
              </div>
              <div v-else>/</div>
            </div>
            <div class="item clearfix">
              <div>本月投入</div>
              <div v-if="item.ygzl">
                <span>{{ item.ygzl }}（人/日）</span>
              </div>
              <div v-else>/</div>
            </div>
          </div>
        </div>
        <div class="card-content-right clearfix">
          <div
            class="item"
            v-for="(item, index) in teamWorks.data1.cy"
            :key="index"
          >
            {{ item.xm }}（{{ item.gwmc }}）
          </div>
        </div>
        <div
          class="all"
          @click="allPeopleDialog = true"
          v-if="teamWorks.data0.zrs > 10"
        >
          ...共{{ teamWorks.data0.zrs }}人
        </div>
      </div>
    </div>
    <div class="card card2">
      <div class="card-title">
        <span v-if="weeklyTime == 3">{{ weekDate }} 项目进展</span>
        <span v-else>{{ weeklyTime == 1 ? "本周" : "上周" }}项目进展</span>
        <el-button
          style="margin-left: 10px"
          size="mini"
          @click="handlePushEdit(1)"
          type="danger"
          >推送编辑</el-button
        >
        <span style="margin-left: 10px; color: red; font-size: 12px"
          >此处的内容将作为周报推送给客户，如未编辑则不推送</span
        >
      </div>
      <div class="content">
        <div
          class="row clearfix"
          v-for="(item, index) in bzzbData"
          :key="index"
        >
          <div class="left-column">{{ item.txlx }}</div>
          <div class="right-column">
            <div
              class="item clearfix"
              v-for="(item2, index2) in item.ryList"
              :key="index2"
            >
              <div>{{ item2.xm }}</div>
              <div>{{ item2.gzl }}人/日</div>
              <div @click="weeklyListDialog = true">{{ item2.gznr }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card card3">
      <div class="card-title">
        <span v-if="weeklyTime == 3">{{ nextWeekDate }} 工作计划</span>
        <span v-else>{{ weeklyTime == 1 ? "下周" : "本周" }}工作计划</span>
        <el-button
          style="margin-left: 10px"
          size="mini"
          @click="handlePushEdit(2)"
          type="danger"
          >推送编辑</el-button
        >
        <span type="info" style="margin-left: 10px; color: red; font-size: 12px"
          >此处的内容将作为周报推送给客户，如未编辑则不推送</span
        >
      </div>
      <div class="content">
        <!-- <div class="item-header clearfix">
          <div>工作内容</div>
          <div>责任人</div>
          <div>计划完成时间</div>
        </div>
        <div class="item-content">
          <div class="item" v-for="(item, index) in xzzbData" :key="index">
            <div>{{ item.gznr }}</div>
            <div>{{ item.xm }}</div>
            <div>{{ item.endtime }}</div>
          </div>
        </div>-->

        <el-table
          :data="xzzbData"
          fit
          highlight-current-row
          style="width: 100%"
          height="228"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="工作内容"
            prop="gznr"
            align="left"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.gznr }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="责任人"
            prop="xm"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.xm }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="计划完成时间"
            prop="endtime"
            align="left"
            min-width="50px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.endtime }}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="card card4">
      <div class="card-title">重点关注</div>
      <div class="content">
        <div class="item first-item">
          <!-- <div >
            <span>风险等级</span><span>{{ xmWeekly.fxdj }}</span>
          </div>-->
          <div>
            <span class>项目阶段</span>
            <el-radio-group v-model="xmWeekly.xmjd" disabled>
              <el-radio
                :label="item.dictValue"
                v-for="(item, index) in xmjd"
                :key="index"
                >{{ item.dictLabel }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <div class="item">
          <div>
            <span>系统日期</span>
            <span>
              <el-date-picker
                v-model="xmWeekly.xtrq"
                type="date"
                placeholder="选择日期"
                size="small"
                value-format="yyyyMMdd"
              ></el-date-picker>
            </span>
          </div>
          <div>
            <span>系统重算天数</span>
            <span>
              <el-input-number
                v-model="xmWeekly.xtcsts"
                :min="0"
                label="描述文字"
                size="small"
              ></el-input-number>
            </span>
          </div>
          <div>
            <span>总调度</span>
            <span>
              <el-input-number
                v-model="xmWeekly.zdd"
                :min="0"
                label="描述文字"
                size="small"
                @change="handleChange"
              ></el-input-number
              >分钟
            </span>
          </div>
        </div>
        <div class="item last-item">
          <div>
            <span>
              数据库与应用服务器使用率最高的磁盘占比
              <span>
                <el-input-number
                  v-model="xmWeekly.sjkcpsyzb"
                  :min="0"
                  :max="100"
                  size="small"
                ></el-input-number
                >%
              </span>
              <span>
                <el-input-number
                  v-model="xmWeekly.ffqcpsyzb"
                  :min="0"
                  :max="100"
                  size="small"
                ></el-input-number
                >%
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="card card5">
      <div class="card-title">项目概况及风险</div>
      <div class="content">
        <div class="row clearfix" v-for="(item, index) in xmfx" :key="index">
          {{ item }}
        </div>
        <div class>
          <el-input
            type="textarea"
            :rows="10"
            placeholder="其他风险补充，1000字以内"
            v-model="xmWeekly.qtfxbc"
            :clearable="true"
            :maxlength="1000"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="card card6">
      <div class="card-title">
        <span>项目风险策略</span>
        <span @click="riskDialog = true">...详情</span>
      </div>

      <div class="content">
        <el-input
          type="textarea"
          :rows="10"
          placeholder="1000字以内"
          v-model="xmWeekly.fxcljxmgk"
          :clearable="true"
          :maxlength="1000"
        ></el-input>
      </div>
    </div>
    <div class="card card7">
      <div class="card-title">
        <span>定期关注</span>
      </div>
      <div class="content">
        <div
          class="card-title"
          style="margin-top: 1px; margin-left: 20px; font-size: 15px"
        >
          <span>绩效薪酬</span>
        </div>
        <div class="row clearfix">
          <div>薪酬总包</div>
          <div>
            上年
            <el-input-number
              v-model="xmWeekly.xczb.last"
              :min="0"
              :step-strictly="true"
              size="small"
              :step="0.01"
              @change="handleChange(xmWeekly.xczb)"
            ></el-input-number
            >万元
          </div>
          <div>
            今年
            <el-input-number
              v-model="xmWeekly.xczb.now"
              @change="handleChange(xmWeekly.xczb)"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            比上年增加
            <el-input
              style="width: 100px"
              v-model="xmWeekly.xczb.difference"
              :disabled="true"
              :class="xmWeekly.xczb.difference < 0 ? 'red' : ''"
            ></el-input
            >万元
          </div>
        </div>
        <div class="row clearfix">
          <div>绩效总包</div>
          <div>
            上年
            <el-input-number
              v-model="xmWeekly.jxzb.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange(xmWeekly.jxzb)"
            ></el-input-number
            >万元
          </div>
          <div>
            今年
            <el-input-number
              v-model="xmWeekly.jxzb.now"
              @change="handleChange(xmWeekly.jxzb)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            比上年增加
            <el-input
              style="width: 100px"
              v-model="xmWeekly.jxzb.difference"
              :disabled="true"
              :class="xmWeekly.jxzb.difference < 0 ? 'red' : ''"
            ></el-input
            >万元
          </div>
        </div>
        <div class="row clearfix">
          <div>系统兑现绩效</div>
          <div>
            上年
            <el-input-number
              v-model="xmWeekly.xtdxjx.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange(xmWeekly.xtdxjx)"
            ></el-input-number
            >万元
          </div>
          <div>
            今年
            <el-input-number
              v-model="xmWeekly.xtdxjx.now"
              :min="0"
              :step="0.01"
              :step-strictly="true"
              size="small"
              @change="handleChange(xmWeekly.xtdxjx)"
            ></el-input-number
            >万元
          </div>
          <div>
            比上年增加
            <el-input
              style="width: 100px"
              v-model="xmWeekly.xtdxjx.difference"
              :disabled="true"
              :class="xmWeekly.xtdxjx.difference < 0 ? 'red' : ''"
            ></el-input
            >万元
          </div>
        </div>
        <div class="row clearfix">
          <div>系统兑现占比</div>
          <div>
            上年
            <el-input-number
              v-model="xmWeekly.xtdxzb.last"
              :min="0"
              :step="0.01"
              size="small"
              :step-strictly="true"
              @change="handleChange(xmWeekly.xtdxzb)"
            ></el-input-number
            >%
          </div>
          <div>
            今年
            <el-input-number
              v-model="xmWeekly.xtdxzb.now"
              :min="0"
              :step="0.01"
              :step-strictly="true"
              size="small"
              @change="handleChange(xmWeekly.xtdxzb)"
            ></el-input-number
            >%
          </div>
          <div>
            比上年增加
            <el-input
              style="width: 100px"
              v-model="xmWeekly.xtdxzb.difference"
              :disabled="true"
              :class="xmWeekly.xtdxzb.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>
        <div class="card-title" style="margin-left: 20px; font-size: 15px">
          <span>经营业绩</span>
        </div>
        <div class="row clearfix">
          <div>省联社排名变化情况</div>
          <div>
            前年排名结果
            <el-input-number
              v-model="xmWeekly.slspmbhqk.last"
              :min="0"
              :step-strictly="true"
              :step="1"
              size="small"
              @change="handleChange2(xmWeekly.slspmbhqk)"
            ></el-input-number
            >名
          </div>
          <div>
            去年排名结果
            <el-input-number
              v-model="xmWeekly.slspmbhqk.now"
              @change="handleChange2(xmWeekly.slspmbhqk)"
              :step-strictly="true"
              :step="1"
              :min="0"
              size="small"
            ></el-input-number
            >名
          </div>
          <div>
            排名变化情况
            <el-input
              style="width: 100px"
              v-model="xmWeekly.slspmbhqk.difference"
              :disabled="true"
              :class="xmWeekly.slspmbhqk.difference < 0 ? 'red' : ''"
            ></el-input
            >名
          </div>
        </div>
        <div class="row clearfix">
          <div>上年总体存款规模任务</div>
          <div>
            上年任务目标
            <el-input-number
              v-model="xmWeekly.ztckgmrwwcqk1.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange1(xmWeekly.ztckgmrwwcqk1)"
            ></el-input-number
            >万元
          </div>
          <div>
            上年完成情况
            <el-input-number
              v-model="xmWeekly.ztckgmrwwcqk1.now"
              @change="handleChange1(xmWeekly.ztckgmrwwcqk1)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            完成率
            <el-input
              style="width: 100px"
              v-model="xmWeekly.ztckgmrwwcqk1.difference"
              :disabled="true"
              :class="xmWeekly.ztckgmrwwcqk1.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>
        <div class="row clearfix">
          <div>半年总体存款规模任务</div>
          <div>
            半年度任务目标
            <el-input-number
              v-model="xmWeekly.ztckgmrwwcqk2.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange1(xmWeekly.ztckgmrwwcqk2)"
            ></el-input-number
            >万元
          </div>
          <div>
            半年度完成情况
            <el-input-number
              v-model="xmWeekly.ztckgmrwwcqk2.now"
              @change="handleChange1(xmWeekly.ztckgmrwwcqk2)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            完成率
            <el-input
              style="width: 100px"
              v-model="xmWeekly.ztckgmrwwcqk2.difference"
              :disabled="true"
              :class="xmWeekly.ztckgmrwwcqk2.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>

        <div class="row clearfix">
          <div>上年总体贷款规模任务</div>
          <div>
            上年任务目标
            <el-input-number
              v-model="xmWeekly.ztdkgmruwcqk1.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange1(xmWeekly.ztdkgmruwcqk1)"
            ></el-input-number
            >万元
          </div>
          <div>
            上年完成情况
            <el-input-number
              v-model="xmWeekly.ztdkgmruwcqk1.now"
              @change="handleChange1(xmWeekly.ztdkgmruwcqk1)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            完成率
            <el-input
              style="width: 100px"
              v-model="xmWeekly.ztdkgmruwcqk1.difference"
              :disabled="true"
              :class="xmWeekly.ztdkgmruwcqk1.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>
        <div class="row clearfix">
          <div>半年总体贷款规模任务</div>
          <div>
            半年度任务目标
            <el-input-number
              v-model="xmWeekly.ztdkgmruwcqk2.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange1(xmWeekly.ztdkgmruwcqk2)"
            ></el-input-number
            >万元
          </div>
          <div>
            半年度完成情况
            <el-input-number
              v-model="xmWeekly.ztdkgmruwcqk2.now"
              @change="handleChange1(xmWeekly.ztdkgmruwcqk2)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            完成率
            <el-input
              style="width: 100px"
              v-model="xmWeekly.ztdkgmruwcqk2.difference"
              :disabled="true"
              :class="xmWeekly.ztdkgmruwcqk2.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>

        <div class="row clearfix">
          <div>上年总体不良压降任务</div>
          <div>
            上年任务目标
            <el-input-number
              v-model="xmWeekly.ztblyjrwwcqk1.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange1(xmWeekly.ztblyjrwwcqk1)"
            ></el-input-number
            >万元
          </div>
          <div>
            上年完成情况
            <el-input-number
              v-model="xmWeekly.ztblyjrwwcqk1.now"
              @change="handleChange1(xmWeekly.ztblyjrwwcqk1)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            完成率
            <el-input
              style="width: 100px"
              v-model="xmWeekly.ztblyjrwwcqk1.difference"
              :disabled="true"
              :class="xmWeekly.ztblyjrwwcqk1.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>
        <div class="row clearfix">
          <div>半年总体不良压降任务</div>
          <div>
            半年度任务目标
            <el-input-number
              v-model="xmWeekly.ztblyjrwwcqk2.last"
              :min="0"
              :step-strictly="true"
              :step="0.01"
              size="small"
              @change="handleChange1(xmWeekly.ztblyjrwwcqk2)"
            ></el-input-number
            >万元
          </div>
          <div>
            半年度完成情况
            <el-input-number
              v-model="xmWeekly.ztblyjrwwcqk2.now"
              @change="handleChange1(xmWeekly.ztblyjrwwcqk2)"
              :step-strictly="true"
              :step="0.01"
              :min="0"
              size="small"
            ></el-input-number
            >万元
          </div>
          <div>
            完成率
            <el-input
              style="width: 100px"
              v-model="xmWeekly.ztblyjrwwcqk2.difference"
              :disabled="true"
              :class="xmWeekly.ztblyjrwwcqk2.difference < 0 ? 'red' : ''"
            ></el-input
            >%
          </div>
        </div>
        <div
          class="card-title"
          style="margin-top: 1px; margin-left: 20px; font-size: 15px"
        >
          <span>考核相关</span>
        </div>
        <div class="item clearfix">
          <div>
            <div class="label">考核管控模式</div>
            <div v-if="khgkms.length > 0" class="options">
              <el-radio-group v-model="xmWeekly.khgkms">
                <el-radio
                  :label="item.dictValue"
                  v-for="(item, index) in khgkms"
                  :key="index"
                  >{{ item.dictLabel }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="item clearfix">
          <div>
            <div class="label">考核覆盖面</div>
            <div v-if="khzdfgm.length > 0" class="options">
              <el-checkbox-group v-model="xmWeekly.khzdfgm">
                <el-checkbox
                  :label="item.dictValue"
                  v-for="(item, index) in khzdfgm"
                  :key="index"
                >
                  <span v-if="item.dictLabel == '其他考核'">
                    {{ item.dictLabel }}
                    <el-input v-model="xmWeekly.khzdfgmqt"></el-input>
                  </span>
                  <span v-else>{{ item.dictLabel }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card card8">
      <div class="card-title">
        <span>客户特殊行为感知</span>
        <div class="content">
          <div class="item">
            <div>
              <div v-if="khtsxwgz.length > 0">
                <el-checkbox-group
                  v-model="xmWeekly.khtsxwgz"
                  @change="khtsxwgzChange"
                >
                  <el-checkbox
                    :label="item.dictValue"
                    v-for="(item, index) in khtsxwgz"
                    :key="index"
                    >{{ item.dictLabel }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!--editRole 用户角色权限1-项目总监 2-区域总监 3-咨询负责人 0普通员工
          enable  编辑模式：1-保存模式 0-提交模式 
          项目总监可提交 
      -->
      <div v-if="weeklyTime != 3">
        <el-button
          v-if="xmWeekly.editRole != 0 && xmWeekly.enable == 1"
          type="primary"
          @click="handleSave(1)"
          >保存</el-button
        >
        <el-button
          type="primary"
          v-if="
            (xmWeekly.editRole.indexOf('1') > -1 ||
              xmWeekly.editRole.indexOf('2') > -1) &&
            xmWeekly.enable == 1
          "
          @click="handleSave(0)"
          >提交</el-button
        >
      </div>
    </div>
    <el-dialog
      title="编辑日志"
      :visible.sync="editLogDialog"
      width="800px"
      append-to-body
      class="share-post"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table
        :data="weeklyLog"
        fit
        highlight-current-row
        style="width: 100%"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="编辑人"
          prop="createBy"
          align="left"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createBy }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="编辑时间"
          prop="createTime"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="编辑字段"
          prop="fieldName"
          align="left"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fieldName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="编辑前"
          prop="editBefore"
          min-width="200px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.editBefore }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="编辑后"
          prop="editAfter"
          min-width="200px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.editAfter }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-dialog>
    <el-dialog
      title="团队明细"
      :visible.sync="allPeopleDialog"
      width="800px"
      append-to-body
      class="share-post"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table
        :data="teamWorks.data1.allCy"
        fit
        highlight-current-row
        style="width: 100%"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="条线"
          prop="txlx"
          align="left"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.txlx }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="人员"
          prop="xm"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="岗位"
          prop="gwmc"
          align="left"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gwmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="本周投入(人/日)"
          prop="zgzl"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.zgzl }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-dialog>
    <el-dialog
      title="工作内容明细"
      :visible.sync="weeklyListDialog"
      width="800px"
      append-to-body
      class="share-post"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="float: right">
        <el-button type="primary" @click="handlExport()">导出</el-button>
      </div>
      <el-table
        :data="workDetails"
        fit
        highlight-current-row
        style="width: 100%"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="条线"
          prop="txlx"
          align="left"
          min-width="50px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.txlx }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="人员"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="岗位"
          prop="gwmc"
          align="left"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gwmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="日期"
          prop="qdrq"
          align="left"
          min-width="100px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.qdrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="工作量（人/日）"
          prop="gzl"
          min-width="130px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gzl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="条线-最佳模型" prop="zjmx" min-width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.zjmx }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="工作内容"
          prop="gznr"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gznr }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-dialog>
    <el-dialog
      title="项目风险策略"
      :visible.sync="riskDialog"
      width="800px"
      append-to-body
      class="share-post"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>{{ xmWeekly.fxcljxmgk }}</div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="周报推送"
      :visible.sync="pushDialog"
      width="90%"
      v-if="pushDialog"
    >
      <Push ref="push" :mxParams="mxParams" @giveFather="getSon"></Push>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSaveEdit">确定</el-button>
        <el-button @click="pushDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getWeeklyList,
  getTeamWorks,
  getWorksDetails,
  getWeeklyLog,
  getDictData,
  getProjectWeekly,
  saveProjectWeekly,
  getExportWorksDetails,
} from "@/api/weekly.js";
import { getYesterday } from "@/utils/utils";
import { MessageBox, Message } from "element-ui";
import axios from "axios";
import Push from "./Push";
export default {
  name: "weekly",
  components: { Push },
  data() {
    return {
      weeklyTime: "1",
      editLogDialog: false,
      allPeopleDialog: false,
      weeklyListDialog: false,
      riskDialog: false,
      pushDialog: false,
      params: {
        xmjc: "",
        xmbh: "",
        xmzq: "",
      },
      mxParams: {},
      weeklyList: [], //本年周报日期
      weekDate: "", //当前查询的周报日期
      nextWeekDate: "",
      weeklyName: "本周",
      weeklyLog: [], //编辑日志
      teamWorks: {
        data0: {
          zrs: "",
          ztr: "",
        },
        data1: {
          fzr: [],
        },
      }, //box1数据
      bzzbData: [], //box2数据，本周周报
      xzzbData: [], //box3数据，下周周报
      workDetails: [], //   box2弹窗
      xmjd: [], //项目节点
      xmWeekly: {
        editRole: "0",
        enable: "0",
        ffqcpsyzb: "",
        fxcljxmgk: "",
        fxdj: "1",
        fxpdzbms: null,
        jsrq: "",
        khgkms: "",
        khtsxwgz: "",
        khzdfgm: [],
        khzdfgmqt: [],
        qsrq: "",
        qtfxbc: "",
        sjkcpsyzb: "",
        tbsj: "",
        updateBy: "",
        xmbh: "",
        xmjd: "1",
        xtcsts: "",
        xtrq: "",
        zbbh: 1,
        zdd: "",
        xczb: {
          difference: 0,
          last: 0,
          now: 0,
          name: "",
          key: "",
        },
        jxzb: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        xtdxjx: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        xtdxzb: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },

        ztckgmrwwcqk1: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        ztckgmrwwcqk2: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        ztdkgmruwcqk1: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        ztdkgmruwcqk2: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        ztblyjrwwcqk1: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        ztblyjrwwcqk2: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
        slspmbhqk: {
          difference: 0,
          last: 0,
          now: 0,
          ame: "",
          key: "",
        },
      }, // 项目周报信息
      lastXmWeekly: {}, //上周项目周报信息，若是本周无数据，将上周的数据代入本周数据
      xmfx: [], // 项目风险
      khgkms: [], //考核管控模式
      khzdfgm: [], //考核制度覆盖面
      khtsxwgz: [], //客户特殊行为感知
    };
  },
  created() {
    let params = null;
    if (localStorage.getItem("params")) {
      params = JSON.parse(localStorage.getItem("params"));
      this.params = params;
    }
    getWeeklyList("").then((res) => {
      if (res.code == 0) {
        this.weeklyList = res.data;
        if (this.params.xmzq == this.weeklyList[0].key_1) {
          this.weekDate = this.weeklyList[0].key_1;
          this.weeklyTime = "1";
        } else if (this.params.xmzq == this.weeklyList[1].key_1) {
          this.weekDate = this.weeklyList[1].key_1;
          this.weeklyTime = "2";
        } else {
          this.weekDate = this.params.xmzq;
          this.weeklyTime = "3";
          for (let i in this.weeklyList) {
            if (this.weekDate == this.weeklyList[i].key_1) {
              this.nextWeekDate = this.weeklyList[+i - 1].key_1;
            }
          }
        }
        this.getData();
      }
    });
  },
  methods: {
    handlePushEdit(type) {
      this.pushDialog = true;
      this.mxParams.xmzq = this.weekDate;
      this.mxParams.xmbh = this.params.xmbh;
      this.mxParams.type = type;
      this.mxParams.weeklyTime = this.weeklyTime; //本周：1，上周：2
    },
    handleSaveEdit() {
      this.$refs.push.handleInsert();
    },
    getSon(temp) {
      this.pushDialog = temp;
    },
    getWeeklyData(value) {
      if (value == 1 && this.weeklyList && this.weeklyList.length > 0) {
        this.weekDate = this.weeklyList[0].key_1;
      } else if (value == 2 && this.weeklyList.length > 0) {
        this.weekDate = this.weeklyList[1].key_1;
      }
      this.getData();
    },
    getData() {
      getTeamWorks(this.params.xmbh, this.weekDate).then((res) => {
        if (res.code == 0) {
          this.teamWorks = res.data;
          let fzr = []; //box1左侧 负责人
          let cy = []; // 右侧 剩余成员
          let allCy = this.teamWorks.data1; // 所有成员
          for (let i of this.teamWorks.data1) {
            if (i.fzr) {
              if (i.fzr.indexOf(",") > -1) {
                for (let j of i.fzr.split(",")) {
                  fzr.push({
                    fzr: j,
                    gwmc: i.gwmc,
                    txlx: i.txlx,
                    xm: i.xm,
                    ygbh: i.ygbh,
                    ygzl: i.ygzl,
                    zgzl: i.zgzl,
                  });
                }
              } else {
                fzr.push(i);
              }
            } else {
              cy.push(i);
            }
          }
          let tempFzr = {
            qyzj: {
              fzr: "区域总监",
              gwmc: null,
              txlx: null,
              xm: null,
              ygbh: null,
              ygzl: null,
              zgzl: null,
            },
            xmzj: {
              fzr: "项目总监",
              gwmc: null,
              txlx: null,
              xm: null,
              ygbh: null,
              ygzl: null,
              zgzl: null,
            },
            zxfzr: {
              fzr: "咨询负责人",
              gwmc: null,
              txlx: null,
              xm: null,
              ygbh: null,
              ygzl: null,
              zgzl: null,
            },
          };
          for (let i of fzr) {
            if (i.fzr == "区域总监") {
              tempFzr.qyzj = i;
              continue;
            } else if (i.fzr == "项目总监") {
              tempFzr.xmzj = i;
              continue;
            } else if (i.fzr == "咨询负责人") {
              tempFzr.zxfzr = i;
              continue;
            } else {
              continue;
            }
          }
          cy = cy.splice(0, 10);
          this.teamWorks.data1;
          this.teamWorks.data1 = [];
          this.teamWorks.data1 = {
            allCy,
            fzr: tempFzr,
            cy,
          };

          // 本周上周周报数据处理
          let bzzbData = []; //本周
          let xzzbData = []; //下周
          for (let i of this.teamWorks.data2) {
            if (i.zq == "本周") {
              bzzbData.push(i);
            } else if (i.zq == "下周") {
              xzzbData.push(i);
            }
          }
          let keyArr = [];
          for (let i of bzzbData) {
            keyArr.push(i.txlx);
          }
          keyArr = [...new Set(keyArr)];
          let tempArr = [];
          for (let i of keyArr) {
            tempArr.push({
              txlx: i,
              ryList: [],
            });
          }
          for (let i of this.teamWorks.data2) {
            for (let j of tempArr) {
              if (i.txlx == j.txlx) {
                j.ryList.push(i);
              }
            }
          }
          this.bzzbData = tempArr;
          this.xzzbData = xzzbData;
          this.teamWorks.data0.ztr = parseFloat(this.teamWorks.data0.ztr, 1);
        }
      });
      getWorksDetails(this.params.xmbh, this.weekDate).then((res) => {
        if (res.code == 0) {
          this.workDetails = res.data;
        }
      });
      getWeeklyLog(this.params.xmbh, this.weekDate).then((res) => {
        if (res.code == 0) {
          this.weeklyLog = res.data;
        }
      });
      // 获取项目阶段数据
      getDictData("xmjd", 2).then((res) => {
        if (res.code == 0) {
          this.xmjd = res.data.splice(1, 2);
        }
      });
      // 获取项目风险数据
      getDictData("xmfx", 2).then((res) => {
        if (res.code == 0) {
          this.xmfx = res.data;
        }
      });
      // 获取项目周报信息
      getProjectWeekly(this.params.xmbh, this.weekDate).then((res) => {
        if (res.code == 0) {
          // if (res.data) {
          // enable == 1 保存模式，能编辑  editRole != 0 有权限编辑周报
          //isEdit  == true 能编辑
          const editRole = res.data?.editRole;
          const enable = res.data?.enable;
          const isEdit = res.data?.enable == 1 && res.data?.editRole != 0;

          //如果有周报编号，说明周报有数据 ，当周报有数据或者没有编辑权限，正常赋值
          if (res.data && (res.data?.zbbh || !isEdit)) {
            this.xmWeekly = {
              ...res.data,
              xczb: {
                difference: 0,
                last: 0,
                now: 0,
                name: "",
                key: "",
              },
              jxzb: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              xtdxjx: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              xtdxzb: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },

              ztckgmrwwcqk1: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              ztckgmrwwcqk2: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              ztdkgmruwcqk1: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              ztdkgmruwcqk2: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              ztblyjrwwcqk1: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              ztblyjrwwcqk2: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
              slspmbhqk: {
                difference: 0,
                last: 0,
                now: 0,
                ame: "",
                key: "",
              },
            };
            //薪酬总包等数据处理
            if (res.data?.xczb) {
              this.xmWeekly.xczb = {
                last: +res.data.xczb.split("_")[0],
                now: +res.data.xczb.split("_")[1],
                difference: (
                  res.data.xczb.split("_")[1] - res.data.xczb.split("_")[0]
                ).toFixed(2),
                name: "薪酬总包",
                key: "xczb",
              };
              this.xmWeekly.jxzb = {
                last: +res.data.jxzb.split("_")[0],
                now: +res.data.jxzb.split("_")[1],
                difference: (
                  res.data.jxzb.split("_")[1] - res.data.jxzb.split("_")[0]
                ).toFixed(2),
                name: "绩效总包",
                key: "jxzb",
              };
              this.xmWeekly.xtdxjx = {
                last: +res.data.xtdxjx.split("_")[0],
                now: +res.data.xtdxjx.split("_")[1],
                difference: (
                  res.data.xtdxjx.split("_")[1] - res.data.xtdxjx.split("_")[0]
                ).toFixed(2),
                name: "系统兑现绩效",
                key: "xtdxjx",
              };
              this.xmWeekly.xtdxzb = {
                last: +res.data.xtdxzb.split("_")[0],
                now: +res.data.xtdxzb.split("_")[1],
                difference: (
                  res.data.xtdxzb.split("_")[1] - res.data.xtdxzb.split("_")[0]
                ).toFixed(2),
                name: "系统兑现占比",
                key: "xtdxzb",
              };
              if (
                res.data.ztckgmrwwcqk1 != null ||
                res.data.ztckgmrwwcqk1 != ""
              ) {
                this.xmWeekly.ztckgmrwwcqk1 = {
                  last: +res.data.ztckgmrwwcqk1.split("_")[0],
                  now: +res.data.ztckgmrwwcqk1.split("_")[1],
                  difference: this.pandaun(
                    (res.data.ztckgmrwwcqk1.split("_")[1] /
                      res.data.ztckgmrwwcqk1.split("_")[0]) *
                      100
                  ).toFixed(2),
                  name: "总体存款规模任务完成情况上年",
                  key: "ztckgmrwwcqk1",
                };
              }
              if (
                res.data.ztckgmrwwcqk2 != null ||
                res.data.ztckgmrwwcqk2 != ""
              ) {
                this.xmWeekly.ztckgmrwwcqk2 = {
                  last: +res.data.ztckgmrwwcqk2.split("_")[0],
                  now: +res.data.ztckgmrwwcqk2.split("_")[1],
                  difference: this.pandaun(
                    (res.data.ztckgmrwwcqk2.split("_")[1] /
                      res.data.ztckgmrwwcqk2.split("_")[0]) *
                      100
                  ).toFixed(2),
                  name: "总体存款规模任务完成情况半年",
                  key: "ztckgmrwwcqk2",
                };
              }
              if (
                res.data.ztdkgmruwcqk1 != null ||
                res.data.ztdkgmruwcqk1 != ""
              ) {
                this.xmWeekly.ztdkgmruwcqk1 = {
                  last: +res.data.ztdkgmruwcqk1.split("_")[0],
                  now: +res.data.ztdkgmruwcqk1.split("_")[1],
                  difference: this.pandaun(
                    (res.data.ztdkgmruwcqk1.split("_")[1] /
                      res.data.ztdkgmruwcqk1.split("_")[0]) *
                      100
                  ).toFixed(2),
                  name: "总体贷款规模任务完成情况上年",
                  key: "ztdkgmruwcqk1",
                };
              }
              if (
                res.data.ztdkgmruwcqk2 != null ||
                res.data.ztdkgmruwcqk2 != ""
              ) {
                this.xmWeekly.ztdkgmruwcqk2 = {
                  last: +res.data.ztdkgmruwcqk2.split("_")[0],
                  now: +res.data.ztdkgmruwcqk2.split("_")[1],
                  difference: this.pandaun(
                    (res.data.ztdkgmruwcqk2.split("_")[1] /
                      res.data.ztdkgmruwcqk2.split("_")[0]) *
                      100
                  ).toFixed(2),
                  name: "总体贷款规模任务完成情况半年",
                  key: "ztdkgmruwcqk2",
                };
              }
              if (
                res.data.ztblyjrwwcqk1 != null ||
                res.data.ztblyjrwwcqk1 != ""
              ) {
                this.xmWeekly.ztblyjrwwcqk1 = {
                  last: +res.data.ztblyjrwwcqk1.split("_")[0],
                  now: +res.data.ztblyjrwwcqk1.split("_")[1],
                  difference: this.pandaun(
                    (res.data.ztblyjrwwcqk1.split("_")[1] /
                      res.data.ztblyjrwwcqk1.split("_")[0]) *
                      100
                  ).toFixed(2),
                  name: "总体不良压降任务完成情况上年",
                  key: "ztblyjrwwcqk1",
                };
              }
              if (
                res.data.ztblyjrwwcqk2 != null ||
                res.data.ztblyjrwwcqk2 != ""
              ) {
                this.xmWeekly.ztblyjrwwcqk2 = {
                  last: +res.data.ztblyjrwwcqk2.split("_")[0],
                  now: +res.data.ztblyjrwwcqk2.split("_")[1],
                  difference: this.pandaun(
                    (res.data.ztblyjrwwcqk2.split("_")[1] /
                      res.data.ztblyjrwwcqk2.split("_")[0]) *
                      100
                  ).toFixed(2),
                  name: "总体不良压降任务完成情况半年",
                  key: "ztblyjrwwcqk2",
                };
              }
              if (res.data.slspmbhqk != null || res.data.slspmbhqk != "") {
                this.xmWeekly.slspmbhqk = {
                  last: +res.data.slspmbhqk.split("_")[0],
                  now: +res.data.slspmbhqk.split("_")[1],
                  difference: (
                    res.data.slspmbhqk.split("_")[0] -
                    res.data.slspmbhqk.split("_")[1]
                  ).toFixed(2),
                  name: "省联社排名变化",
                  key: "slspmbhqk",
                };
              }
            }
            if (this.xmWeekly.khtsxwgz) {
              this.xmWeekly.khtsxwgz = this.xmWeekly.khtsxwgz.split(",");
              this.xmWeekly.khtsxwgz.map((i) => parseInt(i, 0));
            } else {
              this.xmWeekly.khtsxwgz = [];
            }
            if (this.xmWeekly.khzdfgm) {
              this.xmWeekly.khzdfgm = this.xmWeekly.khzdfgm.split(",");
              this.xmWeekly.khzdfgm.map((i) => parseInt(i, 0));
            } else {
              this.xmWeekly.khzdfgm = [];
            }

            if (!this.xmWeekly.xtrq && this.xmWeekly.xmjd != "1") {
              this.xmWeekly.xtrq = getYesterday();
            }
            if (!this.xmWeekly.xtrq && this.xmWeekly.xmjd == "1") {
              this.xmWeekly.xtrq = null;
            }
            // this.xmWeekly.dqgzList = temp;
          } else {
            // 没有周报编号，拥有编辑权限，本周取上周的值 ，上周取上上周的值

            if (this.weeklyTime == "1") {
              //本周取上周的值
              getProjectWeekly(this.params.xmbh, this.weeklyList[1].key_1).then(
                (res) => {
                  if (res.code == 0) {
                    this.xmWeekly = {
                      ...res.data,
                      xczb: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        name: "",
                        key: "",
                      },
                      jxzb: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      xtdxjx: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      xtdxzb: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztckgmrwwcqk1: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztckgmrwwcqk2: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztdkgmruwcqk1: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztdkgmruwcqk2: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztblyjrwwcqk1: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztblyjrwwcqk2: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      slspmbhqk: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                    };
                    //薪酬总包等数据处理
                    if (res.data?.xczb) {
                      this.xmWeekly.xczb = {
                        last: +res.data.xczb.split("_")[0],
                        now: +res.data.xczb.split("_")[1],
                        difference: (
                          res.data.xczb.split("_")[1] -
                          res.data.xczb.split("_")[0]
                        ).toFixed(2),
                        name: "薪酬总包",
                        key: "xczb",
                      };
                      this.xmWeekly.jxzb = {
                        last: +res.data.jxzb.split("_")[0],
                        now: +res.data.jxzb.split("_")[1],
                        difference: (
                          res.data.jxzb.split("_")[1] -
                          res.data.jxzb.split("_")[0]
                        ).toFixed(2),
                        name: "绩效总包",
                        key: "jxzb",
                      };
                      this.xmWeekly.xtdxjx = {
                        last: +res.data.xtdxjx.split("_")[0],
                        now: +res.data.xtdxjx.split("_")[1],
                        difference: (
                          res.data.xtdxjx.split("_")[1] -
                          res.data.xtdxjx.split("_")[0]
                        ).toFixed(2),
                        name: "系统兑现绩效",
                        key: "xtdxjx",
                      };
                      this.xmWeekly.xtdxzb = {
                        last: +res.data.xtdxzb.split("_")[0],
                        now: +res.data.xtdxzb.split("_")[1],
                        difference: (
                          res.data.xtdxzb.split("_")[1] -
                          res.data.xtdxzb.split("_")[0]
                        ).toFixed(2),
                        name: "系统兑现占比",
                        key: "xtdxzb",
                      };
                      if (
                        res.data.ztckgmrwwcqk1 != null ||
                        res.data.ztckgmrwwcqk1 != ""
                      ) {
                        this.xmWeekly.ztckgmrwwcqk1 = {
                          last: +res.data.ztckgmrwwcqk1.split("_")[0],
                          now: +res.data.ztckgmrwwcqk1.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztckgmrwwcqk1.split("_")[1] /
                              res.data.ztckgmrwwcqk1.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体存款规模任务完成情况上年",
                          key: "ztckgmrwwcqk1",
                        };
                      }
                      if (
                        res.data.ztckgmrwwcqk2 != null ||
                        res.data.ztckgmrwwcqk2 != ""
                      ) {
                        this.xmWeekly.ztckgmrwwcqk2 = {
                          last: +res.data.ztckgmrwwcqk2.split("_")[0],
                          now: +res.data.ztckgmrwwcqk2.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztckgmrwwcqk2.split("_")[1] /
                              res.data.ztckgmrwwcqk2.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体存款规模任务完成情况半年",
                          key: "ztckgmrwwcqk2",
                        };
                      }
                      if (
                        res.data.ztdkgmruwcqk1 != null ||
                        res.data.ztdkgmruwcqk1 != ""
                      ) {
                        this.xmWeekly.ztdkgmruwcqk1 = {
                          last: +res.data.ztdkgmruwcqk1.split("_")[0],
                          now: +res.data.ztdkgmruwcqk1.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztdkgmruwcqk1.split("_")[1] /
                              res.data.ztdkgmruwcqk1.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体贷款规模任务完成情况上年",
                          key: "ztdkgmruwcqk1",
                        };
                      }
                      if (
                        res.data.ztdkgmruwcqk2 != null ||
                        res.data.ztdkgmruwcqk2 != ""
                      ) {
                        this.xmWeekly.ztdkgmruwcqk2 = {
                          last: +res.data.ztdkgmruwcqk2.split("_")[0],
                          now: +res.data.ztdkgmruwcqk2.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztdkgmruwcqk2.split("_")[1] /
                              res.data.ztdkgmruwcqk2.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体贷款规模任务完成情况半年",
                          key: "ztdkgmruwcqk2",
                        };
                      }
                      if (
                        res.data.ztblyjrwwcqk1 != null ||
                        res.data.ztblyjrwwcqk1 != ""
                      ) {
                        this.xmWeekly.ztblyjrwwcqk1 = {
                          last: +res.data.ztblyjrwwcqk1.split("_")[0],
                          now: +res.data.ztblyjrwwcqk1.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztblyjrwwcqk1.split("_")[1] /
                              res.data.ztblyjrwwcqk1.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体不良压降任务完成情况上年",
                          key: "ztblyjrwwcqk1",
                        };
                      }
                      if (
                        res.data.ztblyjrwwcqk2 != null ||
                        res.data.ztblyjrwwcqk2 != ""
                      ) {
                        this.xmWeekly.ztblyjrwwcqk2 = {
                          last: +res.data.ztblyjrwwcqk2.split("_")[0],
                          now: +res.data.ztblyjrwwcqk2.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztblyjrwwcqk2.split("_")[1] /
                              res.data.ztblyjrwwcqk2.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体不良压降任务完成情况半年",
                          key: "ztblyjrwwcqk2",
                        };
                      }
                      if (
                        res.data.slspmbhqk != null ||
                        res.data.slspmbhqk != ""
                      ) {
                        this.xmWeekly.slspmbhqk = {
                          last: +res.data.slspmbhqk.split("_")[0],
                          now: +res.data.slspmbhqk.split("_")[1],
                          difference: (
                            res.data.slspmbhqk.split("_")[0] -
                            res.data.slspmbhqk.split("_")[1]
                          ).toFixed(2),
                          name: "省联社排名变化",
                          key: "slspmbhqk",
                        };
                      }
                    }
                    if (this.xmWeekly.khtsxwgz) {
                      this.xmWeekly.khtsxwgz =
                        this.xmWeekly.khtsxwgz.split(",");
                      this.xmWeekly.khtsxwgz.map((i) => parseInt(i, 0));
                    } else {
                      this.xmWeekly.khtsxwgz = [];
                    }
                    if (this.xmWeekly.khzdfgm) {
                      this.xmWeekly.khzdfgm = this.xmWeekly.khzdfgm.split(",");
                      this.xmWeekly.khzdfgm.map((i) => parseInt(i, 0));
                    } else {
                      this.xmWeekly.khzdfgm = [];
                    }
                    this.xmWeekly.xtrq = res.data.xtrq;
                    this.xmWeekly.xtcsts = res.data.xtcsts;
                    this.xmWeekly.sjkcpsyzb = res.data.sjkcpsyzb;
                    this.xmWeekly.ffqcpsyzb = res.data.ffqcpsyzb;
                    this.xmWeekly.editRole = editRole;
                    this.xmWeekly.enable = enable;
                  }
                }
              );
            } else {
              // 上周取上上周的值
              getProjectWeekly(this.params.xmbh, this.weeklyList[2].key_1).then(
                (res) => {
                  if (res.code == 0) {
                    this.xmWeekly = {
                      ...res.data,
                      xczb: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        name: "",
                        key: "",
                      },
                      jxzb: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      xtdxjx: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      xtdxzb: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztckgmrwwcqk1: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztckgmrwwcqk2: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztdkgmruwcqk1: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztdkgmruwcqk2: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztblyjrwwcqk1: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      ztblyjrwwcqk2: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                      slspmbhqk: {
                        difference: 0,
                        last: 0,
                        now: 0,
                        ame: "",
                        key: "",
                      },
                    };
                    //薪酬总包等数据处理
                    if (res.data?.xczb) {
                      this.xmWeekly.xczb = {
                        last: +res.data.xczb.split("_")[0],
                        now: +res.data.xczb.split("_")[1],
                        difference: (
                          res.data.xczb.split("_")[1] -
                          res.data.xczb.split("_")[0]
                        ).toFixed(2),
                        name: "薪酬总包",
                        key: "xczb",
                      };
                      this.xmWeekly.jxzb = {
                        last: +res.data.jxzb.split("_")[0],
                        now: +res.data.jxzb.split("_")[1],
                        difference: (
                          res.data.jxzb.split("_")[1] -
                          res.data.jxzb.split("_")[0]
                        ).toFixed(2),
                        name: "绩效总包",
                        key: "jxzb",
                      };
                      this.xmWeekly.xtdxjx = {
                        last: +res.data.xtdxjx.split("_")[0],
                        now: +res.data.xtdxjx.split("_")[1],
                        difference: (
                          res.data.xtdxjx.split("_")[1] -
                          res.data.xtdxjx.split("_")[0]
                        ).toFixed(2),
                        name: "系统兑现绩效",
                        key: "xtdxjx",
                      };
                      this.xmWeekly.xtdxzb = {
                        last: +res.data.xtdxzb.split("_")[0],
                        now: +res.data.xtdxzb.split("_")[1],
                        difference: (
                          res.data.xtdxzb.split("_")[1] -
                          res.data.xtdxzb.split("_")[0]
                        ).toFixed(2),
                        name: "系统兑现占比",
                        key: "xtdxzb",
                      };
                      if (
                        res.data.ztckgmrwwcqk1 != null ||
                        res.data.ztckgmrwwcqk1 != ""
                      ) {
                        this.xmWeekly.ztckgmrwwcqk1 = {
                          last: +res.data.ztckgmrwwcqk1.split("_")[0],
                          now: +res.data.ztckgmrwwcqk1.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztckgmrwwcqk1.split("_")[1] /
                              res.data.ztckgmrwwcqk1.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体存款规模任务完成情况上年",
                          key: "ztckgmrwwcqk1",
                        };
                      }
                      if (
                        res.data.ztckgmrwwcqk2 != null ||
                        res.data.ztckgmrwwcqk2 != ""
                      ) {
                        this.xmWeekly.ztckgmrwwcqk2 = {
                          last: +res.data.ztckgmrwwcqk2.split("_")[0],
                          now: +res.data.ztckgmrwwcqk2.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztckgmrwwcqk2.split("_")[1] /
                              res.data.ztckgmrwwcqk2.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体存款规模任务完成情况半年",
                          key: "ztckgmrwwcqk2",
                        };
                      }
                      if (
                        res.data.ztdkgmruwcqk1 != null ||
                        res.data.ztdkgmruwcqk1 != ""
                      ) {
                        this.xmWeekly.ztdkgmruwcqk1 = {
                          last: +res.data.ztdkgmruwcqk1.split("_")[0],
                          now: +res.data.ztdkgmruwcqk1.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztdkgmruwcqk1.split("_")[1] /
                              res.data.ztdkgmruwcqk1.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体贷款规模任务完成情况上年",
                          key: "ztdkgmruwcqk1",
                        };
                      }
                      if (
                        res.data.ztdkgmruwcqk2 != null ||
                        res.data.ztdkgmruwcqk2 != ""
                      ) {
                        this.xmWeekly.ztdkgmruwcqk2 = {
                          last: +res.data.ztdkgmruwcqk2.split("_")[0],
                          now: +res.data.ztdkgmruwcqk2.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztdkgmruwcqk2.split("_")[1] /
                              res.data.ztdkgmruwcqk2.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体贷款规模任务完成情况半年",
                          key: "ztdkgmruwcqk2",
                        };
                      }
                      if (
                        res.data.ztblyjrwwcqk1 != null ||
                        res.data.ztblyjrwwcqk1 != ""
                      ) {
                        this.xmWeekly.ztblyjrwwcqk1 = {
                          last: +res.data.ztblyjrwwcqk1.split("_")[0],
                          now: +res.data.ztblyjrwwcqk1.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztblyjrwwcqk1.split("_")[1] /
                              res.data.ztblyjrwwcqk1.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体不良压降任务完成情况上年",
                          key: "ztblyjrwwcqk1",
                        };
                      }
                      if (
                        res.data.ztblyjrwwcqk2 != null ||
                        res.data.ztblyjrwwcqk2 != ""
                      ) {
                        this.xmWeekly.ztblyjrwwcqk2 = {
                          last: +res.data.ztblyjrwwcqk2.split("_")[0],
                          now: +res.data.ztblyjrwwcqk2.split("_")[1],
                          difference: this.pandaun(
                            (res.data.ztblyjrwwcqk2.split("_")[1] /
                              res.data.ztblyjrwwcqk2.split("_")[0]) *
                              100
                          ).toFixed(2),
                          name: "总体不良压降任务完成情况半年",
                          key: "ztblyjrwwcqk2",
                        };
                      }
                      if (
                        res.data.slspmbhqk != null ||
                        res.data.slspmbhqk != ""
                      ) {
                        this.xmWeekly.slspmbhqk = {
                          last: +res.data.slspmbhqk.split("_")[0],
                          now: +res.data.slspmbhqk.split("_")[1],
                          difference: (
                            res.data.slspmbhqk.split("_")[0] -
                            res.data.slspmbhqk.split("_")[1]
                          ).toFixed(2),
                          name: "省联社排名变化",
                          key: "slspmbhqk",
                        };
                      }
                    }
                    if (this.xmWeekly.khtsxwgz) {
                      this.xmWeekly.khtsxwgz =
                        this.xmWeekly.khtsxwgz.split(",");
                      this.xmWeekly.khtsxwgz.map((i) => parseInt(i, 0));
                    } else {
                      this.xmWeekly.khtsxwgz = [];
                    }
                    if (this.xmWeekly.khzdfgm) {
                      this.xmWeekly.khzdfgm = this.xmWeekly.khzdfgm.split(",");
                      this.xmWeekly.khzdfgm.map((i) => parseInt(i, 0));
                    } else {
                      this.xmWeekly.khzdfgm = [];
                    }
                    this.xmWeekly.xtrq = res.data.xtrq;
                    this.xmWeekly.xtcsts = res.data.xtcsts;
                    this.xmWeekly.sjkcpsyzb = res.data.sjkcpsyzb;
                    this.xmWeekly.ffqcpsyzb = res.data.ffqcpsyzb;
                    this.xmWeekly.editRole = editRole;
                    this.xmWeekly.enable = enable;
                  }
                }
              );
            }
          }
          // }
        }
      });
      getDictData("xmgl_khgkms", 1).then((res) => {
        if (res.code == 0) {
          this.khgkms = res.data;
        }
      });
      getDictData("xmgl_khzdfgm", 1).then((res) => {
        if (res.code == 0) {
          this.khzdfgm = res.data;
        }
      });
      getDictData("xmgl_khtsxwgz", 1).then((res) => {
        if (res.code == 0) {
          this.khtsxwgz = res.data;
        }
      });
    },
    //入库模式1为保存 0提交，提交之后就不能再次编辑，且只有项目能操作
    handleSave(enable) {
      if (
        !this.xmWeekly.sjkcpsyzb ||
        !this.xmWeekly.ffqcpsyzb ||
        !this.xmWeekly.xtcsts ||
        !this.xmWeekly.zdd
      ) {
        // this.$message.error("");
        if (this.xmWeekly.xmjd == "1") {
          MessageBox.confirm(
            `重点关注中存在数值为 0 的选项，是否继续${
              enable == 0 ? "提交" : "保存"
            }？`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.savecode(enable);
            })
            .catch(() => {
              return;
            });
        } else {
          this.$message.error("请填写重点关注指标，且不能为0！");
          return;
        }
      } else {
        this.savecode(enable);
      }
    },
    savecode(enable) {
      if (enable == 0) {
        MessageBox.confirm("提交后无法再次编辑周报，是否提交？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let khzdfgmqt = this.xmWeekly.khzdfgmqt;
            if (this.xmWeekly.xmjd != "1") {
              if (this.xmWeekly.khzdfgm.join(",").indexOf("-1") < 0) {
                //未勾选其他考核
                khzdfgmqt = "";
              } else {
                if (!khzdfgmqt) {
                  this.$message.error("请输入考核覆盖面中其他考核的内容！");
                  return;
                }
              }
            }

            const xczb =
              this.xmWeekly.xczb.last +
              "_" +
              this.xmWeekly.xczb.now +
              "_" +
              this.xmWeekly.xczb.difference;
            const jxzb =
              this.xmWeekly.jxzb.last +
              "_" +
              this.xmWeekly.jxzb.now +
              "_" +
              this.xmWeekly.jxzb.difference;
            const xtdxjx =
              this.xmWeekly.xtdxjx.last +
              "_" +
              this.xmWeekly.xtdxjx.now +
              "_" +
              this.xmWeekly.xtdxjx.difference;
            const xtdxzb =
              this.xmWeekly.xtdxzb.last +
              "_" +
              this.xmWeekly.xtdxzb.now +
              "_" +
              this.xmWeekly.xtdxzb.difference;
            const ztckgmrwwcqk1 =
              this.xmWeekly.ztckgmrwwcqk1.last +
              "_" +
              this.xmWeekly.ztckgmrwwcqk1.now +
              "_" +
              this.xmWeekly.ztckgmrwwcqk1.difference;
            const ztckgmrwwcqk2 =
              this.xmWeekly.ztckgmrwwcqk2.last +
              "_" +
              this.xmWeekly.ztckgmrwwcqk2.now +
              "_" +
              this.xmWeekly.ztckgmrwwcqk2.difference;
            const ztdkgmruwcqk1 =
              this.xmWeekly.ztdkgmruwcqk1.last +
              "_" +
              this.xmWeekly.ztdkgmruwcqk1.now +
              "_" +
              this.xmWeekly.ztdkgmruwcqk1.difference;
            const ztdkgmruwcqk2 =
              this.xmWeekly.ztdkgmruwcqk2.last +
              "_" +
              this.xmWeekly.ztdkgmruwcqk2.now +
              "_" +
              this.xmWeekly.ztdkgmruwcqk2.difference;
            const ztblyjrwwcqk1 =
              this.xmWeekly.ztblyjrwwcqk1.last +
              "_" +
              this.xmWeekly.ztblyjrwwcqk1.now +
              "_" +
              this.xmWeekly.ztblyjrwwcqk1.difference;
            const ztblyjrwwcqk2 =
              this.xmWeekly.ztblyjrwwcqk2.last +
              "_" +
              this.xmWeekly.ztblyjrwwcqk2.now +
              "_" +
              this.xmWeekly.ztblyjrwwcqk2.difference;
            const slspmbhqk =
              this.xmWeekly.slspmbhqk.last +
              "_" +
              this.xmWeekly.slspmbhqk.now +
              "_" +
              this.xmWeekly.slspmbhqk.difference;
            let params = {
              zbbh: "",
              xmbh: this.params.xmbh,
              qsrq: this.weekDate.slice(0, 8),
              jsrq: this.weekDate.slice(-8),
              fxdj: 1,
              xmjd: this.xmWeekly.xmjd,
              xtrq: this.xmWeekly.xtrq,
              xtcsts: this.xmWeekly.xtcsts,
              zdd: this.xmWeekly.zdd,
              sjkcpsyzb: this.xmWeekly.sjkcpsyzb,
              ffqcpsyzb: this.xmWeekly.ffqcpsyzb,
              qtfxbc: this.xmWeekly.qtfxbc,
              fxcljxmgk: this.xmWeekly.fxcljxmgk,
              xczb,
              jxzb,
              xtdxjx,
              xtdxzb,
              ztckgmrwwcqk1,
              ztckgmrwwcqk2,
              ztdkgmruwcqk1,
              ztdkgmruwcqk2,
              ztblyjrwwcqk1,
              ztblyjrwwcqk2,
              slspmbhqk,
              khgkms: this.xmWeekly.khgkms,
              khzdfgm: this.xmWeekly.khzdfgm.join(","),
              khzdfgmqt,
              khtsxwgz: this.xmWeekly.khtsxwgz.join(","),
              enable,
            };

            saveProjectWeekly(params).then((res) => {
              if (res.code == 0) {
                if (params.enable == 1) {
                  this.$message({
                    type: "success",
                    message: "您填写的周报保存成功！",
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "您填写的周报提交成功！",
                  });
                }
                this.getData();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          })
          .catch(() => {
            return;
          });
      } else {
        let khzdfgmqt = this.xmWeekly.khzdfgmqt;
        if (this.xmWeekly.xmjd != "1") {
          if (this.xmWeekly.khzdfgm.join(",").indexOf("-1") < 0) {
            //未勾选其他考核
            khzdfgmqt = "";
          } else {
            if (!khzdfgmqt) {
              this.$message.error("请输入考核覆盖面中其他考核的内容！");
              return;
            }
          }
        }
        const xczb =
          this.xmWeekly.xczb.last +
          "_" +
          this.xmWeekly.xczb.now +
          "_" +
          this.xmWeekly.xczb.difference;
        const jxzb =
          this.xmWeekly.jxzb.last +
          "_" +
          this.xmWeekly.jxzb.now +
          "_" +
          this.xmWeekly.jxzb.difference;
        const xtdxjx =
          this.xmWeekly.xtdxjx.last +
          "_" +
          this.xmWeekly.xtdxjx.now +
          "_" +
          this.xmWeekly.xtdxjx.difference;
        const xtdxzb =
          this.xmWeekly.xtdxzb.last +
          "_" +
          this.xmWeekly.xtdxzb.now +
          "_" +
          this.xmWeekly.xtdxzb.difference;
        const ztckgmrwwcqk1 =
          this.xmWeekly.ztckgmrwwcqk1.last +
          "_" +
          this.xmWeekly.ztckgmrwwcqk1.now +
          "_" +
          this.xmWeekly.ztckgmrwwcqk1.difference;
        const ztckgmrwwcqk2 =
          this.xmWeekly.ztckgmrwwcqk2.last +
          "_" +
          this.xmWeekly.ztckgmrwwcqk2.now +
          "_" +
          this.xmWeekly.ztckgmrwwcqk2.difference;
        const ztdkgmruwcqk1 =
          this.xmWeekly.ztdkgmruwcqk1.last +
          "_" +
          this.xmWeekly.ztdkgmruwcqk1.now +
          "_" +
          this.xmWeekly.ztdkgmruwcqk1.difference;
        const ztdkgmruwcqk2 =
          this.xmWeekly.ztdkgmruwcqk2.last +
          "_" +
          this.xmWeekly.ztdkgmruwcqk2.now +
          "_" +
          this.xmWeekly.ztdkgmruwcqk2.difference;
        const ztblyjrwwcqk1 =
          this.xmWeekly.ztblyjrwwcqk1.last +
          "_" +
          this.xmWeekly.ztblyjrwwcqk1.now +
          "_" +
          this.xmWeekly.ztblyjrwwcqk1.difference;
        const ztblyjrwwcqk2 =
          this.xmWeekly.ztblyjrwwcqk2.last +
          "_" +
          this.xmWeekly.ztblyjrwwcqk2.now +
          "_" +
          this.xmWeekly.ztblyjrwwcqk2.difference;
        const slspmbhqk =
          this.xmWeekly.slspmbhqk.last +
          "_" +
          this.xmWeekly.slspmbhqk.now +
          "_" +
          this.xmWeekly.slspmbhqk.difference;
        let params = {
          zbbh: "",
          xmbh: this.params.xmbh,
          qsrq: this.weekDate.slice(0, 8),
          jsrq: this.weekDate.slice(-8),
          fxdj: 1,
          xmjd: this.xmWeekly.xmjd,
          xtrq: this.xmWeekly.xtrq,
          xtcsts: this.xmWeekly.xtcsts,
          zdd: this.xmWeekly.zdd,
          sjkcpsyzb: this.xmWeekly.sjkcpsyzb,
          ffqcpsyzb: this.xmWeekly.ffqcpsyzb,
          qtfxbc: this.xmWeekly.qtfxbc,
          fxcljxmgk: this.xmWeekly.fxcljxmgk,
          xczb,
          jxzb,
          xtdxjx,
          xtdxzb,
          ztckgmrwwcqk1,
          ztckgmrwwcqk2,
          ztdkgmruwcqk1,
          ztdkgmruwcqk2,
          ztblyjrwwcqk1,
          ztblyjrwwcqk2,
          slspmbhqk,
          khgkms: this.xmWeekly.khgkms,
          khzdfgm: this.xmWeekly.khzdfgm.join(","),
          khzdfgmqt,
          khtsxwgz: this.xmWeekly.khtsxwgz.join(","),
          enable,
        };
        saveProjectWeekly(params).then((res) => {
          if (res.code == 0) {
            if (params.enable == 1) {
              this.$message({
                type: "success",
                message: "您填写的周报保存成功！",
              });
            } else {
              this.$message({
                type: "success",
                message: "您填写的周报提交成功！",
              });
            }
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }
    },
    pandaun(item) {
      if (item == "Infinity" || isNaN(item)) {
        return 0;
      } else {
        return item;
      }
    },
    handleChange(item) {
      if (!item.last) {
        item.last = 0;
      }
      if (!item.now) {
        item.now = 0;
      }
      item.difference = (item.now - item.last).toFixed(2);
    },
    handleChange1(item) {
      if (!item.last) {
        item.last = 0;
      }
      if (!item.now) {
        item.now = 0;
      }
      item.difference = this.pandaun((item.now / item.last) * 100).toFixed(2);
    },
    handleChange2(item) {
      if (!item.last) {
        item.last = 0;
      }
      if (!item.now) {
        item.now = 0;
      }
      item.difference = (item.last - item.now).toFixed(2);
    },
    khtsxwgzChange(value) {
      // 6 == 选择了无 其他选项去掉勾选
      if (value.indexOf("6") > -1) {
        this.xmWeekly.khtsxwgz = ["6"];
      }
    },
    handlExport() {
      getExportWorksDetails(this.params.xmbh, this.weekDate).then((res) => {
        if (res.code == 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);

          // axios.get(
          //     window.g.apiUrl +
          //       "system/downloadFile?fileName=" +
          //       fileName +
          //       "&filePath=" +
          //       filePath,
          //     {
          //       responseType: "blob", // 告诉服务器我们需要的响应格式
          //       headers: { "x-token": localStorage.getItem("token") },
          //     }
          //   )
          //   .then((res) => {
          //     const content = res.headers["content-disposition"];
          //     let fileName = decodeURI(
          //       content.split(";")[1].split("filename=")[1]
          //     );
          //     const blob = new Blob([res.data], {
          //       type: 'application/octet-stream"', // 将会被放入到blob中的数组内容的MIME类型
          //     });
          //     // 组装a标签
          //     const elink = document.createElement("a");
          //     // 设置下载文件名
          //     elink.download = fileName;
          //     elink.style.display = "none";
          //     elink.href = URL.createObjectURL(blob);
          //     document.body.appendChild(elink);
          //     elink.click();
          //     document.body.removeChild(elink);
          //   })
          //   .catch((err) => {
          //   });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.weekly-container {
  font-size: 14px;
  padding: 30px;

  .header {
    display: flex;
    align-items: center;
    .xmmc {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 7px;
    }
    div {
      padding: 0 30px;
      box-sizing: border-box;
    }
  }
  .card {
    padding: 15px;
    border-radius: 5px;
    box-shadow: 0 0 10px #ccc;
    line-height: 42px;
    color: #606266;
    box-sizing: border-box;
    .card-title {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .card1 {
    margin-top: 15px;
    .card-content {
      position: relative;
      .card-content-left {
        width: 65%;
        float: left;
        box-sizing: border-box;
        border-right: 2px solid #ccc;

        .card-column {
          float: left;
          width: 33%;
          .item {
            width: 100%;
            display: flex;
            line-height: 42px;
            > div {
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            div:nth-of-type(1) {
              width: 30%;
              min-width: 70px;
            }
          }
        }
        .card-column:nth-last-child(1) {
          .item {
            div:nth-of-type(1) {
              text-align: right;
              margin-right: 15px;
            }
          }
        }
      }

      .card-content-right {
        box-sizing: border-box;
        width: 35%;
        float: left;
        flex-wrap: wrap;
        line-height: 30px;
        column-count: 2;
        position: absolute;
        right: 0;
        top: -5px;
        .item {
          height: 25px;
          padding-left: 40px;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .all {
        float: right;
        color: #036eb8;
        cursor: pointer;
        line-height: 20px;
        right: 0;
        bottom: -10px;
        position: absolute;
      }
    }
  }
  .card2,
  .card5 {
    margin-top: 15px;
    width: calc(50% - 8px);
    float: left;
    margin-right: 15px;
    height: 300px;
    overflow: auto;
    .content {
      .row {
        .left-column {
          float: left;
          width: 45px;
          text-align: left;
        }
        .right-column {
          float: left;
          width: calc(100% - 45px);
          .item {
            div {
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            div:nth-of-type(1) {
              width: 60px;
            }
            div:nth-of-type(2) {
              width: 70px;
            }
            div:nth-of-type(3) {
              width: calc(100% - 130px);
              color: #036eb8;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  // .card2{
  //   .card-title{

  //   }
  // }
  .card3,
  .card6 {
    margin-top: 15px;
    width: calc(50% - 8px);
    height: 300px;
    float: left;
    .item-header,
    .item {
      width: 100%;
      div {
        float: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div:nth-of-type(1) {
        width: calc(100% - 220px);
      }
      div:nth-of-type(2) {
        width: 120px;
      }
      div:nth-of-type(3) {
        width: 100px;
      }
    }
    .item-header {
      font-weight: bold;
    }
  }
  .card2 {
    .content {
      height: calc(100% - 43px);
      overflow: auto;
    }
  }
  .card3 {
    .content {
      height: calc(100% - 42px);
      overflow: auto;
    }
    .item-content {
      height: calc(100% - 43px);
    }
  }
  .card4 {
    width: 100%;
    margin-top: 15px;
    float: left;
    .item {
      display: flex;
      > div {
        // float: left;
        > span {
          margin-right: 15px;
        }
      }
      > div:nth-of-type(1) {
        width: 40%;
      }
      > div:nth-of-type(2) {
        width: 30%;
      }
    }
    .item.last-item,
    .item.first-item {
      > div:nth-of-type(1) {
        width: 100%;
      }
    }
  }
  .card6 {
    .card-title {
      span:nth-of-type(2) {
        float: right;
        color: #036eb8;
        font-weight: normal;
        cursor: pointer;
      }
    }
  }
  .card7 {
    float: left;
    width: 100%;
    margin-top: 15px;
    .row {
      width: 110%;
      margin-bottom: 15px;
      > div {
        float: left;
        width: 26%;
        box-sizing: border-box;
      }
      > div:nth-of-type(1) {
        text-align: right;
        padding-right: 50px;
        width: 19%;
      }
    }
    .item {
      width: 100%;
      .label {
        width: 15%;
        float: left;
        box-sizing: border-box;
        padding-right: 50px;
        text-align: right;
      }
      .options {
        float: left;
        width: 85%;
      }
    }
  }
  .card8 {
    margin-top: 15px;
    float: left;
    width: 100%;
    .item {
      box-sizing: border-box;
    }
  }
  .footer {
    float: left;
    width: 100%;
    margin-top: 30px;
    > div {
      float: right;
    }
  }
}

::v-deep .red.el-input.is-disabled input {
  color: #ff0000;
}
::v-deep .el-tooltip__popper.is-dark {
  max-width: 500px;
}
</style>
